module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Regular.3e52ebf8.woff";